import { isNil } from 'lodash-es'

import {
  ConfigurationState,
  DocumentFileType,
  getProduct,
  isProductDocument,
  ProductDocument,
  Scheme,
} from '../state/configuration'
import { hasCoverOptionItem, isCoverOptionActive } from './coverOptionItem'
import { CoverLevelOption, Quote } from './types'

export interface GeneratedProductDocument extends ProductDocument {
  url: string
}

const getExtensionFromFileType = (fileType?: DocumentFileType) => {
  switch (fileType) {
    case 'HTML':
      return '.html'
    case 'PDF':
      return '.pdf'
    default:
      return '.html'
  }
}

export const getProductDocuments =
  (scheme: Scheme, quote: Quote, coverLevelOption: CoverLevelOption) =>
  (state: ConfigurationState): GeneratedProductDocument[] => {
    const product = getProduct(scheme.schemeCode)(state)

    if (!product) return []

    const generateDocumentUrl = (parts: {
      document: ProductDocument
      insurer: string
      wordingVersion: string
    }) =>
      `/documents/${parts.wordingVersion}/${parts.insurer}.${
        parts.document.id
      }${getExtensionFromFileType(parts.document.fileType)}`

    return product.documents
      .filter(isProductDocument)
      .map((doc) => ({
        doc,
        coverOption: coverLevelOption.coverOptionItems
          ?.filter(hasCoverOptionItem(doc.coverCode))
          ?.find(isCoverOptionActive),
      }))
      .filter(({ doc, coverOption }) => isNil(doc.coverCode) || !isNil(coverOption))
      .map(({ doc, coverOption }) => ({
        ...doc,
        url: generateDocumentUrl({
          document: doc,
          insurer: coverOption?.insurer ?? quote.mainInsurer,
          wordingVersion: quote.wordingVersion,
        }),
      }))
  }
